module.exports = __webpack_public_path__ + "static/img/pic2.f2b9362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic2.png
// module id = 34
// module chunks = 0